import * as yup from "yup";

export const AddResellerValidationSchemaFields = {
    resellerName: yup.string().required("Reseller name is required"),
    logoUrl: yup.string().required("Logo url is required"),
};

export type AddResellerFormValues = {
    resellerName: string;
    logoUrl: string;
};
